import Mustache from "mustache";

export const mustacheSafeRenderHtml = (
  template: string,
  partials: any,
  errorMessage: string
): [string | undefined, string] => {
  try {
    return [undefined, Mustache.render(template, partials)];
  } catch (error) {
    return [errorMessage, template];
  }
};

export const mustacheSafeRender = (
  template: string,
  partials: any,
  errorMessage: string
): [string | undefined, string] => {
  return [undefined, Mustache.render(convertToUnescaped(template), partials)];
};

type ParseResult = [string | undefined, Mustache.TemplateSpans | undefined];

export const mustacheSafeParse = (
  template: string,
  errorMessage: string
): ParseResult => {
  try {
    return [undefined, Mustache.parse(template)];
  } catch (error) {
    return [errorMessage, undefined];
  }
};

// Use unescaped output for variables in non-html contexts
// In mustache templates, {{variable}} is escaped, so we need to convert it to {{{variable}}} for unescaped output
// Only converts tags where the first character after {{ is alphanumeric or space (regular variables)
// to preserve mustache tags like {{#}}, {{/}}, {{^}}, {{>}} or existing triple braces like {{{variable}}}
export function convertToUnescaped(value: string): string {
  return value.replace(
    /(?<!\{)\{\{([a-zA-Z0-9\s][^{}]*)\}\}(?!\})/g,
    "{{{$1}}}"
  );
}
